import styled from 'styled-components';

export const TitleBar = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 28px;

  h1 {
    margin: 0;
    font-size: 18px;
    line-height: 27px;
    color: ${(props) => props.theme.colors.nero};
  }
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 20px;
`;
